
export const GET_ALL_DEMO_DATA = 'GET_ALL_DEMO_DATA';
export const SUBMIT_DEMO_PAPER = 'SUBMIT_DEMO_PAPER';